import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { RawFoodSubscription } from 'features/Landings/screens/RawFoodSubscription'

const RawFoodSubscriptionPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('raw-food-subscription:page-title')}</title>
        <meta name="title" content={t('raw-food-subscription:page-title')} />
        <meta name="description" content={t('raw-food-subscription:meta-description')} />
        <meta
          name="keywords"
          content="raw dog food subscription, dog food subscription, dog food subscriptions, raw food subscription for dogs, best dog food subscription, subscription dog food, fresh dog food subscription, dog food monthly subscription, dog food subscription service, dog raw food diet subscription, subscription meal plan for dogs"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <RawFoodSubscription />
    </>
  )
}

export default RawFoodSubscriptionPage
